import createIsSubmitting from './selectors/isSubmitting';
import plain from './structure/plain';

export default createIsSubmitting(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/isSubmitting.js
// module id = 504
// module chunks = 0